<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
      <el-table
      :data="log_infos"
      style="width: 100%">
      <el-table-column
        label="头像"
        width="80"
      >
      <template slot-scope="scope">
        <img :src="scope.row.wechat_data.headimgurl" class="avatar">
      </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="日期"
        width="180">
      </el-table-column>
      <el-table-column
        prop="wechat_data.nickname"
        label="用户姓名"
        width="150">
      </el-table-column>
      <el-table-column
        label="性别"
        width="80">
      <template slot-scope="scope">
        <span>
          {{convertSex(scope.row.wechat_data.sex)}}
        </span>
      </template>
      </el-table-column>
      <el-table-column
        prop="wechat_data.province"
        label="省份"
        width="100">
      </el-table-column>
      <el-table-column
        prop="wechat_data.country"
        label="国家"
        width="80">
      </el-table-column>
      <el-table-column
        prop="qrid"
        label="来源码ID"
        width="110">
      </el-table-column>
      <el-table-column
        prop="qrname"
        label="来源码名称"
        width="180">
      </el-table-column>
      <el-table-column
        prop="qrdest"
        label="来源码地址"
        width="280">
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="page"
      :page-size.sync="num"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total_elements">
    </el-pagination>
        </el-card>
        </el-col>
    </el-row>
    </div>
</template>
<script type="text/javascript">
import {get_wechat_track_logs_by_owner} from '@/api/qr_utils.js'
export default {
  name: 'wechatTrack',
  data () {
    return {
      page: this.$route.params.page,
      num: this.$route.params.num,
      log_infos: null,
      total_elements: 0,
    }
  },
  mounted () {
    this.update_track_logs(this.page, this.num)
  },
  methods: {
    convertSex (val) {
      switch (val) {
        case 1:
          return '男'
        case 2:
          return '女'
        default:
          return '未知'
      }
    },
    update_track_logs (page, num) {
      get_wechat_track_logs_by_owner(page, num).then(response=> {
        let response_data = response.data.data.content
        for (let rdi in response_data) {
          if (response_data[rdi].wechatTrackUserInfo) {
            response_data[rdi].wechat_data = JSON.parse(response_data[rdi].wechatTrackUserInfo)
          }
        }
        this.log_infos = response_data
        this.total_elements = response.data.data.totalElements
      })
    },
    handleSizeChange (val) {
        this.update_track_logs(this.page, val)
    },
    handleCurrentChange (val) {
        this.update_track_logs(val, this.num)
    }
  }
}
</script>
<style type="text/css" scoped>
.box-card {
  margin: 10px 15px;
}
.avatar {
  width: 35px;
  height: 35px;
  border-radius: 35px;
}
.pagination {
  margin-top: 20px;
}
</style>
